import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';

import { ReportTableDropdown } from 'src/app/reports/components/reports-lists/models/reports.model';
import { SharedService } from '../../services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dropdown-radio-selection',
  templateUrl: './dropdown-radio-selection.component.html',
  styleUrls: ['./dropdown-radio-selection.component.scss']
})
export class DropdownRadioSelectionComponent {

  @Input() dropDownOption: ReportTableDropdown | null = null;
  @Input() showInvalueText: boolean = true;
  @Input() chartAnalysis: boolean = false;
  @Input() json_data: boolean = false;
  @Output() dropDownValue: EventEmitter<boolean> = new EventEmitter();
  
  languageSub$: Subscription = new Subscription();
  langName = 'en';
  
  selectedRadio: any = '';

  constructor(private shareService :SharedService) {

  }
  ngOnchanges(): void {
  }
  ngOnInit(): void {
     this.languageSub$ = this.shareService.language$.subscribe(lang => {
      this.langName = lang;
     })
    this.selectedRadio = this.json_data ? this.dropDownOption?.data.find((item: any) => item.id == this.dropDownOption?.default) : this.dropDownOption?.default;
  }
  selectRadioValue(value: any, name: any, menuTrigger: MatMenuTrigger) {
    this.selectedRadio = this.json_data ? {value : name} : name;
    this.dropDownValue.emit(this.json_data ? name[1] : value)
    menuTrigger.closeMenu();
  }

}
